import { render, staticRenderFns } from "./OrderDiscountAdd.vue?vue&type=template&id=2ba36b3e"
import script from "./OrderDiscountAdd.vue?vue&type=script&lang=js"
export * from "./OrderDiscountAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports